import { render, staticRenderFns } from "./ButtonTake.vue?vue&type=template&id=23cafa57&"
import script from "./ButtonTake.vue?vue&type=script&lang=ts&"
export * from "./ButtonTake.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports